import React, { useEffect, useState } from "react";

export default function SpaceImageUpload({
  formData,
  setFormData,
  isDisabledEverything,
}) {
  const [selectedMapImagePreview, setSelectedMapImagePreview] = useState([]);

  const handleSelectImageFile = (e) => {
    // now adding new selected files
    const selectedFiles = e.target.files;
    console.log("selectedFiles", selectedFiles);
    const selectedFilesArray = Array.from(selectedFiles);

    if (selectedFilesArray.length === 0) return;

    setFormData((prev) => ({
      ...prev,
      mapImage: selectedFilesArray[0],
    }));

    const filesArray = selectedFilesArray.map((file) => {
      return {
        blobUrl: URL.createObjectURL(file),
        size: file.size,
        type: file.type,
        name: file.name,
      };
    });

    setSelectedMapImagePreview((prev) => [...filesArray]);
  };

  useEffect(() => {
    if (formData?.mapImage && !selectedMapImagePreview?.length) {
      setSelectedMapImagePreview([
        {
          url: formData?.mapImage,
        },
      ]);
    }
  }, [formData?.mapImage]);

  console.log(selectedMapImagePreview);

  return (
    <div className="col-12 col-lg-7">
      <div className="">
        <h6 className="c-uploadimage-label">Upload Map</h6>
        <span className="messageInfo">
          PNG,JPG, GIF, AVI Files are accepted
        </span>
        <div className="">
          <label htmlFor="" className="">
            <input
              type="file"
              name="map-image"
              className="file-upload1"
              id="upload-map-image"
              accept=".png,.jpg,.jpeg,.gif,"
              onChange={handleSelectImageFile}
            />
            <span className="c-uploadimage-text">
              Maximum file size should not be more than{" "}
              <strong>&nbsp;20MB</strong>
            </span>
          </label>
          {selectedMapImagePreview.length > 0 &&
            selectedMapImagePreview?.map((file) => (
              <>
                {file?.blobUrl ? (
                  <div style={{ position: "relative" }} key={file.name}>
                    <img
                      src={file.blobUrl}
                      alt={file.blobUrl}
                      style={{ height: 100, width: 100, borderRadius: 10 }}
                    />
                  </div>
                ) : (
                  <div style={{ position: "relative" }} key={file.name}>
                    <img
                      alt={file.url}
                      src={`${process.env.REACT_APP_SPACES_IMAGE_URL}${file.url}`}
                      style={{ height: 100, width: 100, borderRadius: 10 }}
                    />
                  </div>
                )}
              </>
            ))}
        </div>
      </div>
    </div>
  );
}
